import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name,
  business_name: payload.business_name,
  address: payload.address,
  customer_id: payload.customer_id
})
var crud = new Crud('Branches', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  branches: [],
  catalog: {
    customers: []
  }
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions,
  resetRecords ({ commit }) {
    commit('SET_RECORDS', {
      data: [],
      currentPage: 1,
      perPage: 5,
      totalUsers: 0,
      totalPages: 0
    })
  }
}

const getters = {
  ...crud.getters,
  branches: state => state.branches
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
